// extracted by mini-css-extract-plugin
export default {"submit":"CreatePcpPage_submit__Y-01i"};